export class Tratamiento {
    model = {
        id: { value: null, export: false },
        control_efectivo: {
            value: null, header: 'CONTROL EFECTIVO', required: 'Campo requerido'
        },
        control_ayuda: { header: 'CONTROL AYUDA A MODIFICAR (DISMINUIR):', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        probabilidad: { header: 'PROBABILIDAD', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        descripcion: { header: 'DESCRIPCIÓN DE LA CONSECUENCIA', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', table: true },
        consecuencias: { header: 'CONSECUENCIAS', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        probabilidad_p1: { header: 'probabilidad_p1', value: null, required: false },
        impacto: { header: 'impacto', value: null, required: false },
        nivel_riesgo_residual: { header: 'NIVEL DEL RIESGO RESIDUAL', value: null, required: false },
        alrt_tolerancia_riesgo: { header: 'NIVEL DEL RIESGO RESIDUAL', value: null, required: false },
        alrt_tolerancia_riesgo_residual: { header: 'ALERTA TOLERANCIA DE RIESGO RESIDUAL', value: null, required: false },
        evaluacion_riesgo_ranqueo: { header: 'EVALUACIÓN DEL RIESGO', value: null, required: 'Selecione una opcion' },
        trmto_riesgo: { header: 'TRATAMIENTO DEL RIESGO', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: true, table: true },
    }
}
